import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useForm } from '../../hooks/ useForm'
import MessageAlert from '../../components/tools/MessageAlert'
import { startLoginEmailAndPassword, startLoginEmailPassword } from '../../helpers/auth'
import { useDispatch } from 'react-redux'


const LoginView = () => {
    const dispatch = useDispatch();
    const [errorLogin, setErrorLogin] = useState(false)
    const [loading, setLoading] = useState(false)
    const [messageError, setMessageError] = useState('')
    const [formValues, handleInputChange] = useForm({codigo: '', password: ''});
    const {codigo, password} = formValues;

    const loginWithEmailPassword = async (e) => {
        e.preventDefault();
        setLoading(true)
        let correo = codigo+'@unibague.edu.co';
        await startLoginEmailAndPassword(correo,password)
        .then( async user => {
            dispatch(await startLoginEmailPassword(user))
            setLoading(false)
        })
        .catch(e => {
            setErrorLogin(true);
            setMessageError(e.message)
            setLoading(false)
            setTimeout(() => {
                setErrorLogin(false)
                setMessageError('')
            },10000)
        })

    }

    useEffect(  () => {

        return () => {
            clearTimeout()
        }
    }, [errorLogin])



    return (
        <div className='auth_contenedor'>
            <div className='contenedor_login'>
                <div className='contenedor_login_header'>
                    <h1 className='title'>Docentes</h1>
                </div>
                <div className='contenedor_inputs'>
                    <form onSubmit={loginWithEmailPassword}>
                        <div className='group_inputs'>
                            <input 
                                placeholder="Usuario"
                                type="text"
                                name="codigo"
                                value={codigo}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className='group_inputs'>
                            <input 
                                placeholder="Contraseña"
                                type="password"
                                name="password"
                                value={password}
                                onChange={handleInputChange}
                            />
                        </div>
                        { errorLogin && <MessageAlert alert='dan' msg={messageError} /> }
                        {
                            loading
                            ? <h2>Cargando...</h2>
                            :<button className='btn btn_info' type="submit">Iniciar Sesión</button>
                        }
                        
                        <div className='group_links'>
                            <Link to="/auth/register">No tienes cuenta ?</Link>
                            <a href='!#' className='element_link'>¿Olvidaste la contraseña?</a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default LoginView
